import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import Fuse from 'fuse.js';

import DropDownSearchResultsContainer from 'presentation/containers/__demo__/DropDownSearchResultsContainer.js';
import IconContainer from 'presentation/components/icons/IconContainer';

import styles from 'presentation/components/styles/__demo__/DemoSelfService.css';
let cx = classnames.bind(styles);

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focusIndex: -1,
      fuse: createFuse(props.answersKB),
      shouldShowDropDown: false,
      value: '',
    };

    const searchPropTypes = {
      answersKB: PropTypes.array,
      onClear: PropTypes.func.isRequired,
      onSearch: PropTypes.func.isRequired,
      onSelectAnswer: PropTypes.func.isRequired,
      prompt: PropTypes.string.isRequired,
      searchResults: PropTypes.array,
    };
    PropTypes.checkPropTypes(searchPropTypes, props, 'prop', 'Search');

    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderSearchIcon = this.renderSearchIcon.bind(this);
    this.renderClearIcon = this.renderClearIcon.bind(this);
    this.updateFocusIndex = this.updateFocusIndex.bind(this);
  }

  handleBlur(ev) {
    this.setState({ focusIndex: -1, shouldShowDropDown: false });
  }

  handleChange(ev) {
    this.props.onSearch({ fuse: this.state.fuse, searchTerm: ev.target.value });
    this.setState({ focusIndex: -1, shouldShowDropDown: true, value: ev.target.value });
  }

  handleClear(ev) {
    ev.preventDefault();
    this.props.onClear();
    this.setState({ focusIndex: -1, shouldShowDropDown: false, value: '' });
    this.input.focus();
  }

  handleFocus(ev) {
    this.input.focus();
    this.setState({ shouldShowDropDown: true });
  }

  handleKeyDown(ev) {
    if (this.props.searchResults.length > 0) {
      if (ev.key === 'ArrowUp') {
        ev.preventDefault();
        this.updateFocusIndex(-1);
      } else if (ev.key === 'ArrowDown') {
        ev.preventDefault();
        this.updateFocusIndex(1);
      } else if (ev.key === 'Enter') {
        if (this.state.focusIndex > -1) {
          ev.preventDefault();
          this.props.onSelectAnswer(this.props.searchResults[this.state.focusIndex].id);
        }
      }
    }
  }

  handleMouseDown() {
    this.props.onMouseDown(this.props.answerId);
  }

  handleSubmit(ev) {
    let firstAnswer = this.props.searchResults[0];
    ev.preventDefault();
    // dont send unless there is at least one non-whitespace character, and there is a valid answer in results
    if (/\S+/.test(this.state.value) && typeof firstAnswer !== 'undefined') {
      this.props.onSelectAnswer(firstAnswer.id);
      this.setState({ focusIndex: -1, shouldShowDropDown: false, value: '' });
    }
  }

  render() {
    return (
      <div className="search_wrapper" onBlur={this.handleBlur} onSubmit={this.handleSubmit} role="searchbox">
        <form className={styles.SS_searchForm}>
          {this.renderSearchIcon()}
          <input
            className={styles.SS_inputBox}
            tabIndex="0"
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            onKeyDown={this.handleKeyDown}
            placeholder="Search"
            type="text"
            ref={input => (this.input = input)}
            value={this.state.value}
          />
          <span>{this.renderClearIcon()}</span>
        </form>
        <DropDownSearchResultsContainer
          currentFocusIndex={this.state.focusIndex}
          onBlur={this.handleBlur}
          onClick={this.handleClear}
          onKeyDown={this.handleKeyDown}
          shouldShowDropDown={this.state.shouldShowDropDown}
          tabIndex="0"
          role="button"
          value={this.state.value}
        />
      </div>
    );
  }

  updateFocusIndex(value) {
    let max = this.props.searchResults.length;
    if (max === 0) {
      return;
    }
    let temp = this.state.focusIndex;
    temp += value;
    if (temp < 0) {
      temp = max - 1;
    }
    temp = Math.abs(temp) % (max + 1);
    this.setState({ focusIndex: temp });
  }

  renderSearchIcon() {
    return (
      <IconContainer viewBox="0 0 512 512" className={styles.searchIcon}>
        <path
          fill="currentColor"
          d="M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395 312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5 0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208 32s176 78.7 176 176-78.7 176-176 176z"
        />
      </IconContainer>
    );
  }

  renderClearIcon() {
    return (
      <IconContainer viewBox="0 0 512 512" className={styles.clearButton}>
        <path
          fill="currentColor"
          d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
        />
      </IconContainer>
    );
  }
}

function createFuse(kb) {
  let options = {
    id: 'id',
    // shouldSort: true,
    // includeScore: true,
    // threshold: 0.2,
    // location: 0,
    // distance: 100,
    // maxPatternLength: 32,
    // minMatchCharLength: 1,
    keys: ['name'],
  };

  return new Fuse(kb, options);
}

export default Search;
